/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICRTouchConnection } from './ICRTouchConnection';
import {
    ICRTouchConnectionFromJSON,
    ICRTouchConnectionFromJSONTyped,
    ICRTouchConnectionToJSON,
    ICRTouchConnectionToJSONTyped,
} from './ICRTouchConnection';

/**
 * 
 * @export
 * @interface CreateIcrTouchConnectionResponse
 */
export interface CreateIcrTouchConnectionResponse {
    /**
     * 
     * @type {ICRTouchConnection}
     * @memberof CreateIcrTouchConnectionResponse
     */
    data: ICRTouchConnection;
}

/**
 * Check if a given object implements the CreateIcrTouchConnectionResponse interface.
 */
export function instanceOfCreateIcrTouchConnectionResponse(value: object): value is CreateIcrTouchConnectionResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateIcrTouchConnectionResponseFromJSON(json: any): CreateIcrTouchConnectionResponse {
    return CreateIcrTouchConnectionResponseFromJSONTyped(json, false);
}

export function CreateIcrTouchConnectionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateIcrTouchConnectionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ICRTouchConnectionFromJSON(json['data']),
    };
}

  export function CreateIcrTouchConnectionResponseToJSON(json: any): CreateIcrTouchConnectionResponse {
      return CreateIcrTouchConnectionResponseToJSONTyped(json, false);
  }

  export function CreateIcrTouchConnectionResponseToJSONTyped(value?: CreateIcrTouchConnectionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ICRTouchConnectionToJSON(value['data']),
    };
}

